export default __webpack_public_path__ + "static/media/requirement_forge.1f45b310.jpg";